import * as React from 'react';
import { RouteComponentProps } from 'react-router-dom';
import './AirbackInfoPageContainer.scss';
import * as queryString from 'query-string';
import { TRANSFER_RULES_TEXTS } from '../lib/consts';
const icon = require('../assets/no_requests.svg');

interface RouteProps extends RouteComponentProps<{}> {
    match: any;
    history: any;
}

interface TransferRulesPageContainerState {
    service: string;
    tariff: string;
}

export class TransferRulesPageContainer extends React.Component<RouteProps, TransferRulesPageContainerState> {
    state = {
        service: '',
        tariff: ''
    };

    componentDidMount() {
        const {history} = this.props;
        if (history.location.search) {
            const params = queryString.parse(history.location.search);
            if (params.service) {
                this.setState({service: params.service});
            }
            if (params.tariff) {
                this.setState({tariff: params.tariff});
            }
        }
    }

    render() {
        const {service, tariff} = this.state;
        let infoTexts = (!!service || !!tariff)
            ? TRANSFER_RULES_TEXTS.find(info =>
                !!tariff && info.tariff === tariff || (!tariff && !!service && info.service === service))
            : undefined;
        let texts = infoTexts ? (infoTexts as any).text : undefined;
        if (!infoTexts || !texts) {
            return (
                <div className='search-result__wrapper_error transfer_rules'>
                    <img src={icon} />
                    <div className='search-result__group'>
                        <div className='not-found' style={{textAlign: 'center'}}>
                            Страница не найдена
                        </div>
                    </div>
                </div>
            );
        }
        texts = texts.split('- ').filter(text => !!text);

        return (
            <div className={`airback-info-container ${tariff} ${service} transfer_rules`}>
                {texts && texts.map((text, i) => {
                    if (i % 2 === 1) {
                        return ;
                    }
                    const nextText = texts[i + 1];
                    return <div
                        className='airback-info-container__block'
                        key={i}
                    >
                        <div className='airback-info-container__text_balloon'>
                            <b
                                dangerouslySetInnerHTML={{__html: text ? `- ${text.split('\n').join('<br/>')}` : ''}}
                            />
                            {nextText && <div
                                dangerouslySetInnerHTML={{__html: nextText ? `- ${nextText.split('\n').join('<br/>')}` : ''}}
                            />}
                        </div>
                    </div>;
                })}
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/K24Mobile/TransferRulesPageContainer.tsx